import { apiConfig } from '../constants';
import axios from 'axios';
import { getJwt } from '../utils';

const apiBaseUrl =
  process.env.NODE_ENV === 'production' ? apiConfig.baseUrl.prod : apiConfig.baseUrl.dev;

const getAuthHeader = token => ({
  Authorization: 'Bearer ' + (token ?? getJwt()),
});

export const loginService = (username, password) => {
  return axios({
    method: 'POST',
    data: { username: username.trim(), password: password.trim() },
    url: `${apiBaseUrl}/login`,
  }).then(res => {
    return res.data;
  });
};

export const checkUsername = username => {
  return axios({
    method: 'GET',
    url: `${apiBaseUrl}/user/name/check/${username}`,
  }).then(res => {
    return res.data.data;
  });
};

export const loginCheckService = () => {
  return axios({
    method: 'GET',
    headers: {
      ...getAuthHeader(),
    },
    url: `${apiBaseUrl}/auth/check`,
  }).then(res => {
    return res.data;
  });
};

export const saveTestKata = (jsonContent, isPublishedLevel) => {
  return axios({
    method: 'POST',
    data: {
      jsonContent,
      isPublished: isPublishedLevel.isPublished,
      level: Number(isPublishedLevel.level),
    },
    url: `${apiBaseUrl}/kata`,
    headers: {
      ...getAuthHeader(),
    },
  }).then(res => {
    return res.data.data;
  });
};

export const getAllKata = () => {
  return axios({
    method: 'GET',
    url: `${apiBaseUrl}/kata/all`,
  }).then(res => {
    return res.data;
  });
};

export const getMyKata = () => {
  return axios({
    method: 'GET',
    url: `${apiBaseUrl}/kata/me`,
    headers: {
      ...getAuthHeader(),
    },
  }).then(res => {
    return res.data;
  });
};

export const getKataById = id => {
  return axios({
    method: 'GET',
    url: `${apiBaseUrl}/kata/all/${id}`,
  }).then(res => {
    return res.data;
  });
};

export const deleteKataById = id => {
  return axios({
    method: 'DELETE',
    url: `${apiBaseUrl}/kata/${id}`,
    headers: {
      ...getAuthHeader(),
    },
  }).then(res => {
    return res.data;
  });
};

export const updateTest = (id, data) => {
  return axios({
    method: 'PUT',
    data,
    headers: {
      ...getAuthHeader(),
    },
    url: `${apiBaseUrl}/kata/${id}`,
  }).then(res => {
    return res.data;
  });
};

export const register = data => {
  return axios({
    method: 'POST',
    data,
    url: `${apiBaseUrl}/user/register`,
  }).then(res => {
    return res.data;
  });
};
